import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthProvider";
import { UserService } from "@/services/users/UserService";
import type { TeamMember } from "@/types/auth/auth";

/** The signed-in user's workspace members (empty without a team). */
export const useTeamMembers = () => {
  const { team } = useAuth();
  return useQuery<TeamMember[]>({
    queryKey: ["team-members", team?.id],
    queryFn: async () => (await UserService.getTeamData(team!.id, team!.owner_id))?.members ?? [],
    enabled: !!team,
    staleTime: 5 * 60 * 1000,
  });
};
